define([
    'underscore'
], function() {
    var MailAddressesParser = function(text) {
        var list = text.replace(/,/, ' ').split(/(\t|\s|\n)+/);
        list = _.filter(list, function(val) {
            val = val.replace(/\s/, '');
            if (val.length > 0) {
                return val;
            }
        });

        return list;
    };

    return MailAddressesParser;
});



// WEBPACK FOOTER //
// ./common/util/mail-addresses-parser.js